import { jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { styles } from "./ClampLines.css.mjs";
const ClampLines = ({
  numLines = "1",
  originalText = "",
  children
}) => {
  const { base, wordBreak, lineClamp } = styles;
  const clampStyle = lineClamp[numLines];
  const wordBreakStyle = numLines === "1" ? wordBreak.singleLine : wordBreak.multiLine;
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: [base, clampStyle, wordBreakStyle],
      ...originalText ? { title: originalText } : {},
      children
    }
  );
};
export {
  ClampLines
};
